import {
  VisualAssessmentCatalogsTable,
  VisualAssessmentCatalogsTableFilters,
  useDefaultHtzVisualAssessmentCatalogListRequest,
} from "@/services/backend/htz/inspection/components/visual-assessment-catalogs-table";
import { CreateVisualAssessmentCatalogDialog } from "@/services/backend/htz/inspection/components/create-visual-assessment-catalog-dialog";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { NavLink } from "react-router";
import { ReactNode, useCallback, useState } from "react";

export function VisualAssessmentCatalogsRoute() {
  const [request, setRequest] = useState(
    useDefaultHtzVisualAssessmentCatalogListRequest(),
  );

  const renderRowLink = useCallback(
    (catalogId: string, children: ReactNode) => (
      <NavLink to={catalogId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Kataloge für Visuelle Beurteilungen")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Kataloge für Vorlagen für visuelle Beurteilungen erstellt werden.",
          )}
        </CardDescription>
        <CardAction>
          <CreateVisualAssessmentCatalogDialog />
        </CardAction>
      </CardHeader>
      <CardContent className="grid gap-2">
        <VisualAssessmentCatalogsTableFilters
          request={request}
          onRequestChange={setRequest}
        />
        <VisualAssessmentCatalogsTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
          hideBorder
        />
      </CardContent>
    </Card>
  );
}
